const mode = process.env.VUE_APP_MODE || 'dev'
console.log(mode)
// debug环境
// export default 'http://192.168.0.252:8011'

// live环境
// export default 'http://peys.totodi.com:17811'

// release环境
// export default 'http://pe.totodi.com:13811'

// 深圳通测试环境
// export default 'http://peys.totodi.com:37811'

const config = {
  dev: 'http://192.168.0.252:8011', // 开发
  test: 'http://peys.totodi.com:27811', // 测试
  testtx: 'https://petx.totodi.com', // 腾讯云测试
  jryhd: 'https://graytestopenapi.totodi.com',
  live: 'http://peys.totodi.com:17811', // 演示
  prod: 'http://pe.totodi.com:13811' // 生产
}

/*
  androidInvestorUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=208', // 投资者
  androidFinancialUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=210', // 企业版
  iosInvestorUrl: 'https://itunes.apple.com/cn/app/妥私募/id1332550394?mt=8',
  iosFinancialUrl: 'https://itunes.apple.com/cn/app//id1332552677',
*/
const appDownloadConfig = {
  testtx: {
    androidInvestorUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=461',
    androidFinancialUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=462',
    iosInvestorUrl: 'https://testflight.apple.com/join/9WfoQy4A',
    iosFinancialUrl: 'https://testflight.apple.com/join/i7gLVOgn'
  },
  other: {
    androidInvestorUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=208', // 投资者
    androidFinancialUrl: 'http://peys.totodi.com:9990/downloadapk.php?pid=210', // 企业版
    iosInvestorUrl: 'https://itunes.apple.com/cn/app/妥私募/id1332550394?mt=8',
    iosFinancialUrl: 'https://itunes.apple.com/cn/app//id1332552677'
  }
}

export const appDownload = appDownloadConfig[mode] || appDownloadConfig.other

export default config[mode]



// WEBPACK FOOTER //
// ./src/api/baseurl.js